import { ISessionInfo } from "src/bffmodels/ISessionInfo";
import { cdataFetch } from "../cdataFetch";

export function getUserSession() {
  return cdataFetch<ISessionInfo>({
    url: "/users/session",
    method: "GET",
  });
}
